export default __webpack_public_path__ + "static/media/3step.95042366.png";